import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { AutoCompleteModule } from 'primeng/autocomplete';
import { CalendarModule } from 'primeng/calendar';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { PanelModule } from 'primeng/panel';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { InputNumberModule } from 'primeng/inputnumber';

import { HisSharedModule } from 'hisng';

import { CommonSharedModule } from 'app/fs/res/common/common-shared.module';
import { CreateBudgetSourceDialogComponent } from './component/shared/budget-source/create-budget-source-dialog.component';
import { EditResearchContractsComponent } from './component/shared/research-contract/edit-research-contracts.component';
import { ResearchContractFundsComponent } from './component/shared/research-contract/research-contract-funds.component';
import { NoDataTabComponent } from './component/shared/no-data-tab/no-data-tab.component';
import { ResearchContractFundsDialogComponent } from './component/shared/research-contract/research-contract-funds-dialog.component';
import { EditResearchContractFundsComponent } from './component/shared/research-contract/edit-research-contract-funds.component';
import { EditResearchContractAdvancedDataComponent }
    from './component/shared/research-contract/edit-research-contract-advanceddata.component';

/**
 * SharedModule for projects.
 */
@NgModule( {
    imports: [
        // Angular
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,

        // primeng
        AutoCompleteModule,
        CalendarModule,
        ConfirmDialogModule,
        DialogModule,
        InputNumberModule,
        InputTextModule,
        InputTextareaModule,
        PanelModule,
        TabViewModule,
        TableModule,

        // Common
        CommonSharedModule,

        // HIS
        HisSharedModule
    ],
    declarations: [
        EditResearchContractsComponent,
        ResearchContractFundsComponent,
        CreateBudgetSourceDialogComponent,
        ResearchContractFundsDialogComponent,
        EditResearchContractFundsComponent,
        EditResearchContractAdvancedDataComponent,
        NoDataTabComponent
    ],
    exports: [
        EditResearchContractsComponent,
        ResearchContractFundsComponent,
        CreateBudgetSourceDialogComponent,
        ResearchContractFundsDialogComponent,
        EditResearchContractFundsComponent,
        EditResearchContractAdvancedDataComponent,
        NoDataTabComponent
    ]
    // NO PROVIDERS! Providers need to go into FinanceCoreModule
} )
export class FinanceSharedModule {
}
